module.exports = __webpack_public_path__ + "static/img/rodapeLogo.5beadd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/TCE-AL/rodapeLogo.png
// module id = g8fZ
// module chunks = 1